<template>
  <div class="service-create">
    <a-card title="创建服务" size="small" :bordered="false">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" layout="vertical">
        <a-form-model-item label="服务名称" prop="service_name">
          <a-input v-model="form.service_name" placeholder="请输入服务名称" />
        </a-form-model-item>
        <a-form-model-item label="备注信息" prop="description">
          <a-textarea v-model="form.description" :rows="2" placeholder="请输入备注信息" />
        </a-form-model-item>
        <a-form-model-item label="消息通知群聊" prop="chat_ids">
          <chat-select v-model="form.chat_ids" />
        </a-form-model-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="服务类型" prop="service_type">
              <a-select v-model="form.service_type" placeholder="请选择服务类型" @change="handleTypeChange">
                <a-select-option :value="1"> 后端 </a-select-option>
                <a-select-option :value="2"> 前端 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="依赖版本" prop="version">
              <a-select v-model="form.version" placeholder="请选择依赖版本" @change="handleVersionChange">
                <a-select-option v-for="item in versionOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="仓库地址" prop="git_project">
          <gitlab-project-select v-model="form.git_project" />
        </a-form-model-item>
        <a-form-model-item label="Dockerfile" prop="dockerfile">
          <code-mirror-component v-model="form.dockerfile" language="dockerfile" />
        </a-form-model-item>
        <a-form-model-item v-if="[1].includes(form.service_type)" label="基础配置(自动发布配置文件路径)" prop="infra_change">
          <a-input v-model="form.infra_change" placeholder="请填写基础配置目录" />
        </a-form-model-item>
        <a-form-model-item label="发布策略" prop="strategy">
          <a-select v-model="form.strategy" mode="multiple">
            <a-select-option v-for="(item, key) in serviceStrategys" :key="key" :value="item.name">
              <a-tag :color="item.color">{{ item.name }}</a-tag>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 4 }">
          <a-button type="primary" :loading="loading" @click="submitForm"> 提交 </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import ChatSelect from '@/components/FeiShu/ChatSelect';
import CodeMirrorComponent from '@/components/CodeMirrorComponent';
import GitlabProjectSelect from '@/pages/system/components/GitlabProjectSelect';

import { tagList } from '@/api/system/tag';
import { serviceCreateApply, getDockerfileTemplate } from '@/api/system/service';

export default {
  name: 'ServiceCreate',
  components: { ChatSelect, GitlabProjectSelect, CodeMirrorComponent },
  data() {
    return {
      form: {
        name: null,
        service_type: undefined,
        version: undefined,
        dockerfile: null,
        description: null,
        git_project: null,
        chat_ids: [],
        strategy: []
      },
      rules: {
        service_name: [
          { required: true, message: '请输入服务名称', trigger: 'blur' },
          { pattern: /^[a-z-]+$/, message: '服务名称只能包含小写字母和连字符(-)', trigger: 'blur' },
          { min: 5, message: '服务名称长度必须大于5个字符', trigger: 'blur' }
        ],
        service_type: [{ required: true, message: '请选择服务类型', trigger: 'change' }],
        version: [{ required: true, message: '请选择依赖版本', trigger: 'change' }],
        git_project: [{ required: true, message: '请输入仓库地址', trigger: 'change' }],
        chat_ids: [{ required: true, message: '请选择通知群聊', trigger: 'change' }],
        strategy: [{ required: true, message: '请选择发布策略', trigger: 'change' }],
        description: [{ required: true, message: '请输入服务备注', trigger: 'blur' }],
        dockerfile: [{ required: true, message: '请输入Dockerfile', trigger: 'blur' }]
      },
      loading: false,
      chatList: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      versionOptions: [],
      serviceStrategys: []
    };
  },
  created() {
    this.getTagData();
  },
  methods: {
    handleTypeChange() {
      this.form.version = undefined;
      this.form.dockerfile = undefined;
      this.getVersionOptions();
    },
    getVersionOptions() {
      getDockerfileTemplate({
        category: this.form.service_type
      })
        .then(res => {
          this.versionOptions = res.data.items;
        })
        .catch(() => {});
    },

    getTagData() {
      tagList({ group_code: 'release_strategy' }).then(res => {
        const tags = {};
        res.data.items.forEach(item => {
          tags[item.name] = item;
        });
        this.serviceStrategys = tags;
      });
    },

    handleVersionChange() {
      this.form.dockerfile = this.versionOptions.find(item => item.id === this.form.version).content;
    },

    submitForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          const params = { ...this.form, git_id: this.form.git_project.key };
          if (this.projectId !== null) {
            params.projects = [this.projectId];
          }
          delete params.git_project;
          serviceCreateApply({ ...params })
            .then(res => {
              this.loading = false;
              this.$message.success('创建服务成功，正在为您跳转至构建详情页');
              // 跳转至构建详情页
              this.$router.push({
                name: 'page:project:cicd:pipeline:detail',
                query: { recordId: res.data.record_id }
              });
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.service-create {
  padding: 24px;
  background: #fff;

  .ant-card {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    width: 80%;
    margin: 0 auto;
  }

  .ant-form {
    max-width: 840px;
    margin: 0 auto;
  }
}

::v-deep.ant-form-item {
  margin-bottom: 8px;
}
</style>
